interface ReleaseSuccessHeroProps {
  title: string;
  description: string;
  statusLabel: string;
  orderId?: string;
}

export function ReleaseSuccessHero({ title, description, statusLabel, orderId }: ReleaseSuccessHeroProps) {
  return (
    <section className="bg-surface-lowest rounded-4 shadow-kiosk-sm p-4 p-lg-5 d-flex flex-column align-items-center text-center mb-3 mb-lg-4">
      <div
        className="rounded-circle bg-surface-highest d-flex align-items-center justify-content-center text-success mb-3"
        style={{ width: 72, height: 72 }}
      >
        <i className="bi bi-check-circle-fill" style={{ fontSize: 34 }} />
      </div>

      <h2 className="text-headline-sm text-on-surface mb-2">{title}</h2>
      <p className="text-body-sm text-on-surface-variant mb-3" style={{ maxWidth: 420 }}>
        {description}
      </p>

      <span className="badge bg-surface-container text-on-surface-variant fw-medium d-flex align-items-center gap-1 flex-wrap justify-content-center">
        <span className="rounded-circle bg-success flex-shrink-0" style={{ width: 8, height: 8 }} />
        {statusLabel}
        {orderId && <span className="text-on-surface-variant"> · Order #{orderId}</span>}
      </span>
    </section>
  );
}
